var jwtDecode = require('jwt-decode');

export function isAuthenticated() {
  if (localStorage.getItem('accessToken')) {
    let tokenData = Object.assign(
      {},
      jwtDecode(localStorage.getItem('accessToken'))
    );
    let expDate = new Date(Number(tokenData.exp));
    return expDate > Date.now();
  }
  return false;
}

export function hasRole(role) {
  let user = JSON.parse(localStorage.getItem('user'));
  if (user) return user.roles.includes(role);
  return false;
}

export function getUserInitials() {
  let user = JSON.parse(localStorage.getItem('user'));
  if (user) return user.initials;
}

export function getUserId() {
  let user = JSON.parse(localStorage.getItem('user'));
  if (user) return Number(user.id);
}



// WEBPACK FOOTER //
// ./src/services/authService.js